import type { MouseEvent } from 'react';

import { IconButton } from '~/components/IconButton';

import { useGetDdexDownloadLink } from '../api/queries/useGetDdexDownloadLink';

interface DownloadDdexInfoProps {
  id: string;
}

export function DownloadDdexInfo({ id }: DownloadDdexInfoProps) {
  const { data, refetch, isFetching } = useGetDdexDownloadLink(id);

  const handleDownload = async () => {
    try {
      if (!data && !isFetching) {
        const response = await refetch();

        if (response.data?.presigned_url) {
          window.open(response.data.presigned_url, '_blank');
        }
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <IconButton
      asLink
      linkTo={data?.presigned_url ?? ''}
      target="_blank"
      rel="noopener noreferrer"
      iconType="arrow-down-to-line"
      iconVariant="light"
      size="medium"
      className="ml-sm text-hover"
      data-testid="download-icon"
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        handleDownload();
      }}
    />
  );
}

DownloadDdexInfo.displayName = 'DownloadDdexInfo';
